import {
    BUYER_ID,
    getBuiltSurvey,
    SurveyQuestion,
} from '../../../models/survey';
import { CheckoutState } from '../../../state';
import { getTaxIdName } from '../../order/typedOrderSelectors';
import {
    getInteractiveQuestionsByAttendeeId,
    getQuestionsCollection,
} from '../pureSelectors';

/**
 * @private Do not use this directly, derive information from `getSurvey` instead
 */
export const getQuestionsForBuyer = (
    state: CheckoutState,
): Array<SurveyQuestion> => {
    const questions = getQuestionsCollection(state);
    const interactiveQuestionsByAttendeeId =
        getInteractiveQuestionsByAttendeeId(state);
    const taxIdName = getTaxIdName(state);

    return getBuiltSurvey(
        questions,
        interactiveQuestionsByAttendeeId[BUYER_ID] ?? [],
        () => true,
        taxIdName,
    );
};
